import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import ManageUser from "./ManageUser";
import { useDispatch, useSelector } from "react-redux";
import UserSetting from "./UserSetting";
import dayjs from "dayjs";
import FakeUser from "./FakeUser";
import NewFakeUser from "../../dialogue/NewFakeUser";
import { getUserStatsData } from "../../store/user/user.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconUser,
  IconPremiumRights,
  IconUserQuestion,
  IconUserCheck,
  IconUserCircle,
  IconUserOff,
  IconRosetteDiscountCheck,
  IconBroadcast,
} from "@tabler/icons-react";

export default function UserPage() {
  const dispatch = useDispatch();
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { userStatsData } = useSelector((state) => state.user);

  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("User");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getUserStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Users",
      count: userStatsData?.totalUsers,
      Icon: IconUser,
    },
    {
      title: "Total Premium Users",
      count: userStatsData?.totalPremiumUsers,
      Icon: IconPremiumRights,
    },
    {
      title: "Total Fake Users",
      count: userStatsData?.totalFakeUsers,
      Icon: IconUserQuestion,
    },
    {
      title: "Total Real Users",
      count: userStatsData?.totalRealUsers,
      Icon: IconUserCheck,
    },
    {
      title: "Active Users",
      count: userStatsData?.activeUsers,
      Icon: IconUserCircle,
    },
    {
      title: "Total Blocked Users",
      count: userStatsData?.totalBlockedUsers,
      Icon: IconUserOff,
    },
    {
      title: "Total Verified Users",
      count: userStatsData?.totalVerifiedUsers,
      Icon: IconRosetteDiscountCheck,
    },
    {
      title: "Currently Live Users",
      count: userStatsData?.currentlyLiveUsers,
      Icon: IconBroadcast,
    },
  ];

  return (
    <div className="userPage">
      <div
        style={{
          display: `${
            dialogueType === "manageUser"
              ? "none"
              : dialogueType === "hostSettleMent"
              ? "none"
              : dialogueType === "hostHistory"
              ? "none"
              : dialogueType === "fakeUserAdd"
              ? "none"
              : dialogueType === "hostReport"
              ? "none"
              : "block"
          }`,
        }}
      >
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            name={`User`}
            labelData={["User", "Fake User"]}
          />
        </div>

        <StatsCards cards={statsCards} />

        {multiButtonSelect == "User" && (
          <ManageUser
            endDate={endDateData}
            startDate={startDateData}
            multiButtonSelectNavigate={setMultiButtonSelect}
          />
        )}
        {multiButtonSelect == "Fake User" && (
          <FakeUser endDate={endDateData} startDate={startDateData} />
        )}
      </div>

      {dialogueType == "manageUser" && (
        <UserSetting
          multiButtonSelectNavigate={multiButtonSelect}
          multiButtonSelectNavigateSet={setMultiButtonSelect}
        />
      )}
      {dialogueType == "fakeUserAdd" && <NewFakeUser />}
    </div>
  );
}
